module.exports = __webpack_public_path__ + "img/device01.2e5cd44d.png";